export const firebaseConfig = {
    apiKey: "AIzaSyADefK6-uu7wA4MDtcaXjAJ47voTpB1YUA",
    authDomain: "logilink-b67ce.firebaseapp.com",
    projectId: "logilink-b67ce",
    storageBucket: "logilink-b67ce.firebasestorage.app",
    messagingSenderId: "542987541229",
    appId: "1:542987541229:web:dacf6d5abe2ecd2c458ae4"
};
